export enum RewardType {
  customerReferralReward = 'customerReferralReward',
  retailerConnectReward = 'retailerConnectReward',
  promoteBrandClubCashBackReward = 'promoteBrandClubCashBackReward',
  purchaseCashBackReward = 'purchaseCashBackReward',
  limitedTimePurchaseCashBackReward = 'limitedTimePurchaseCashBackReward',
  productReviewCashBackReward = 'productReviewCashBackReward',
  affiliateLinkCashBackReward = 'affiliateLinkCashBackReward',
  socialReward = 'socialReward', // Deprecated
  surveyReward = 'surveyReward',
  contentReward = 'contentReward',
  pageScanReward = 'pageScanReward', // Deprecated
  syncReward = 'syncReward',
  cashOutFeeReward = 'cashOutFeeReward', // Internal only
}

export const rewardDisplayNames: Record<RewardType, string> = {
  [RewardType.customerReferralReward]: 'App Referral Reward',
  [RewardType.retailerConnectReward]: 'Connect Reward',
  [RewardType.promoteBrandClubCashBackReward]: 'Membership Reward',
  [RewardType.purchaseCashBackReward]: 'Purchase Reward',
  [RewardType.limitedTimePurchaseCashBackReward]: 'Daily Deal Reward',
  [RewardType.productReviewCashBackReward]: 'Review Reward',
  [RewardType.affiliateLinkCashBackReward]: 'Affiliate Reward',
  [RewardType.surveyReward]: 'Survey Reward',
  [RewardType.contentReward]: 'Content Reward',
  [RewardType.syncReward]: 'Sync Reward',
  [RewardType.socialReward]: '',
  [RewardType.pageScanReward]: '',
  [RewardType.cashOutFeeReward]: 'Cash Out Fee',
};

export const rewardShortDisplayNames: Record<RewardType, string> = {
  [RewardType.customerReferralReward]: 'Referral',
  [RewardType.retailerConnectReward]: 'Connect',
  [RewardType.promoteBrandClubCashBackReward]: 'Membership',
  [RewardType.purchaseCashBackReward]: 'Purchase',
  [RewardType.limitedTimePurchaseCashBackReward]: 'Daily Deal',
  [RewardType.productReviewCashBackReward]: 'Review',
  [RewardType.affiliateLinkCashBackReward]: 'Affiliate',
  [RewardType.surveyReward]: 'Survey',
  [RewardType.contentReward]: 'Content',
  [RewardType.syncReward]: 'Sync',
  [RewardType.socialReward]: '',
  [RewardType.pageScanReward]: '',
  [RewardType.cashOutFeeReward]: 'Cash Out Fee',
};
